export default __webpack_public_path__ + "static/media/ajanvaraus-grey.9a09a991.svg";